import React from 'react'
// eslint-disable-next-line react/prop-types
const DoubleArrowBack =({className}) => <svg  className={className} width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 1.41L10.42 6L15 10.59L13.59 12L7.59 6L13.59 0L15 1.41Z" fill="#41A017"/>
  <path d="M8 1.41L3.42 6L8 10.59L6.59 12L0.59 6L6.59 0L8 1.41Z" fill="#41A017"/>
  </svg>

export default DoubleArrowBack
